// on window load

window.onload = function() {
    // attach to all .dropdown-trigger
    var dropdowns = document.querySelectorAll('.dropdown-trigger');
    for (var i = 0; i < dropdowns.length; i++) {
        dropdowns[i].addEventListener('click', function() {
            // toggle the class .active on the parent
            this.parentNode.classList.toggle('active');
        });
    }
}